import request from '@/utils/request';

import type { FetchTripResp, TripDataType } from './trip.data';

export async function createTrip(params: any) {
  return request.post(`/cms/trips`, {
    data: params,
  });
}

export async function fetchTrips(params?: any): Promise<FetchTripResp> {
  return request.get('/cms/trips', {
    params,
  });
}

export async function getTripDetail(id: string): Promise<TripDataType> {
  return request.get(`/cms/trips/${id}`);
}

export async function updateTrip(id: string, params: any) {
  return request.patch(`/cms/trips/${id}`, {
    data: params,
  });
}

export async function deleteTrip(id: string) {
  return request.delete(`/cms/trips/${id}`);
}

export async function markAsTemplate(
  id: string,
  params: MarkAsTemplateParams,
): Promise<TripDataType> {
  return request.patch(`/cms/trips/${id}/marks-as-template`, {
    data: params,
  });
}

export type MarkAsTemplateParams = {
  isTemplate: boolean;
};
